module.exports = __webpack_public_path__ + "static/media/check-with-gray-circle.1ed64320.svg";